'use strict';

import {Dropdown} from './dropdown.js';

export class DropdownGroupPacompare extends Dropdown {
	constructor(component_key) {
		super(component_key);
		this.id_mapping = {
			0  : 'dropdown_pacomparedropdown_default', 1 : 'dropdown_pacomparedropdown_default_2',
			2 : 'dropdown_pacomparedropdown_overlay', 3 : 'dropdown_pacomparedropdown_overlay_2',
			4 : 'dropdown_pacomparedropdown_book_upgrade', 5 : 'dropdown_pacomparedropdown_book_upgrade_2'
		}
	}
	
	init() {
		const selectors = [
			'.js-dropdown_pacomparedropdown_default',
			'.js-dropdown_pacomparedropdown_default_2',
			'.js-dropdown_pacomparedropdown_overlay',
			'.js-dropdown_pacomparedropdown_overlay_2',
			
			'.js-dropdown_pacomparedropdown_overlay_book_upgrade',
			'.js-dropdown_pacomparedropdown_overlay_book_upgrade_2'
		];
		
		// initial run
		this.init_all(selectors);
		
		// observe future DOM changes
		this.observe_dom(selectors);
	}
	
	init_all(selectors) {
		selectors.forEach((selector, index) => {
			jQuery(selector).each((_, el) => {
				this.init_h(jQuery(el), index);
			});
		});
	}
	
	
	init_h($root, index) {
		//const $root = jQuery(element);
		let this_id = (this.id_mapping[index]);
		if (!$root.data('initialized')) {
			const $list = $root.find(`.js-${this_id}_list`);
			const $selected = $root.find(`.js-${this_id}_selected`);
			const $options = $list.find(`.js-${this_id}_option`);
			this.add_events($root, $list, $selected, $options, this_id);
			$root.data('initialized', true);
		}
	}
	
	observe_dom(selectors) {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				mutation.addedNodes.forEach((node) => {
					if (!(node instanceof HTMLElement)) return;
					
					selectors.forEach((selector, index) => {
						// node itself
						if (node.matches?.(selector)) {
							this.init_h(jQuery(node), index);
						}
						
						// or children inside the node
						jQuery(node)
							.find(selector)
							.each((_, el) => {
								this.init_h(jQuery(el), index);
							});
					});
				});
			});
		});
		
		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	}
	
	
	close_by_root($root, index) {
		let this_id = (this.id_mapping[index]);
		const $list = $root.find(`.js-${this_id}_list`);
		const $selected = $root.find(`.js-${this_id}_selected`);
		
		yalwa.basics.bem_modifier($list, 'active', 'remove');
		if ($list.find(`.js-${this_id}_option`).length) {
			yalwa.basics.bem_modifier($list.find(`.js-${this_id}_option`), 'active', 'remove');
		}
		if ($selected.find(`.js-${this_id}_option`).length) {
			yalwa.basics.bem_modifier($selected.find(`.js-${this_id}_option`), 'active', 'remove');
		}
	}
	
	inject_context($root, $list, $selected, $options, id) {
		this.$root = $root;
		this.$list = $list;
		this.$selected = $selected;
		this.$options = $options;
		this.id = id;
	}
	
	
	hide_inactive_plans(id) {
		const $tabs = jQuery('.js-tabs_pa_durations_tab');
		const selected_month = $tabs.attr('data-selected-month');
		if (!selected_month) return;
		const data = yalwa.v.components.tabs_pa_durations_tab?.json_data;
		if (!data?.month_wise_plans?.[selected_month]) return;
		const active = data.month_wise_plans[selected_month];
		jQuery(`.js-${id}_option`).each((_, el) => {
			const $el = jQuery(el);
			if (!active.includes($el.data('id'))) {
				$el.hide();
			}
		});
	}

	add_events($root, $list, $selected, $options, id) {
		this.inject_context($root, $list, $selected, $options, id);
		
		this.$selected.on("click", (event) => {
			event.stopPropagation();
			this.inject_context($root, $list, $selected, $options, id);
			const $this = jQuery(event.currentTarget);
			super.selected_click_handler(event);
		
			
			if (id === 'dropdown_pacomparedropdown_default') {
				this.close_by_root(jQuery('.js-dropdown_pacomparedropdown_default_2'), 1);
				//Check which one is selected in dropdown 2
				const $selected_options_2 = jQuery('.js-dropdown_pacomparedropdown_default_2_selected > .js-dropdown_pacomparedropdown_default_2_option');
				const second_plan_type = $selected_options_2.eq(0).data('id');
				jQuery(`.js-${id}_option`).show();
				this.hide_inactive_plans(id);
				jQuery(`.js-${id}_option[data-id="${second_plan_type}"]`).hide();
				
			}
			
			if (id === 'dropdown_pacomparedropdown_default_2') {
				this.close_by_root(jQuery('.js-dropdown_pacomparedropdown_default'), 0);
				const $selected_options_1 = jQuery('.js-dropdown_pacomparedropdown_default_selected > .js-dropdown_pacomparedropdown_default_option');
				const first_plan_type  = $selected_options_1.eq(0).data('id');
				jQuery(`.js-${id}_option`).show();
				this.hide_inactive_plans(id);
				jQuery(`.js-${id}_option[data-id="${first_plan_type}"]`).hide();
			}
			
			if (id === 'dropdown_pacomparedropdown_overlay') {
				this.close_by_root(jQuery('.js-dropdown_pacomparedropdown_overlay_2'), 3);
				//Check which one is selected in dropdown 2
				const $selected_options_2 = jQuery('.js-dropdown_pacomparedropdown_overlay_2_selected > .js-dropdown_pacomparedropdown_overlay_2_option');
				const second_plan_type = $selected_options_2.eq(0).data('id');
				jQuery(`.js-${id}_option`).show();
				this.hide_inactive_plans(id);
				jQuery(`.js-${id}_option[data-id="${second_plan_type}"]`).hide();
				
			}
			if (id === 'dropdown_pacomparedropdown_overlay_2') {
				this.close_by_root(jQuery('.js-dropdown_pacomparedropdown_overlay'), 2);
				const $selected_options_1 = jQuery('.js-dropdown_pacomparedropdown_overlay_selected > .js-dropdown_pacomparedropdown_overlay_option');
				const first_plan_type  = $selected_options_1.eq(0).data('id');
				jQuery(`.js-${id}_option`).show();
				this.hide_inactive_plans(id);
				jQuery(`.js-${id}_option[data-id="${first_plan_type}"]`).hide();
			}
			
		});
		
		$list.on("click", `.js-${this.id}_option`, (event) => {
			let $current_selected = this.$selected.html();
			let current_selected_id = this.$selected.find(`.js-${this.id}_option`).data('id');
			const $element = jQuery(event.currentTarget);
		
			if ($element.data('id') === current_selected_id) {
				this.close_all(event);
				return;
			}
			
			let context = 'default';
			if ($element.hasClass('js-dropdown_pacomparedropdown_overlay_option') || $element.hasClass('js-dropdown_pacomparedropdown_overlay_2_option')) {
				context = 'overlay';
			}
			
			this.option_click_handler(event);
			//real functionality
			const $selected_options_1 = jQuery(`.js-dropdown_pacomparedropdown_${context}_selected > .js-dropdown_pacomparedropdown_${context}_option`);
			const $selected_options_2 = jQuery(`.js-dropdown_pacomparedropdown_${context}_2_selected > .js-dropdown_pacomparedropdown_${context}_2_option`);
		
			const first_plan_type  = $selected_options_1.eq(0).data('id');
			const second_plan_type = $selected_options_2.eq(0).data('id');
			if (first_plan_type === second_plan_type ) {
				//Reset
				this.$selected.html($current_selected);
				return;
			}
			
			const collect_plain_html = (plan_type) => {
				context =  (context === 'overlay') ? context : 'default';
				
				return jQuery(`.js-comparegrid_compare_features[data-context="${context}"`).find(`.js-plan_detail_body > .js-plan_detail[data-type="${plan_type}"]`)
					.map((_, el) => el.outerHTML)
					.get()
					.join('');
			};
			const first_html  = collect_plain_html(first_plan_type);
			const second_html = collect_plain_html(second_plan_type);
			jQuery('.js-compare_data_mobile_first').html(first_html);
			jQuery('.js-compare_data_mobile_second').html(second_html);

			//update the price
			let price_button_1_html = jQuery('.js-get_started_data[data-type="'+first_plan_type+'"]').html();
			let price_button_2_html = jQuery('.js-get_started_data[data-type="'+second_plan_type+'"]').html();
			let $temp_wrapper = jQuery('<div>').html(price_button_1_html);
			$temp_wrapper.find('.js-btn_upgrade').attr('variant', 'outline')
			let price_button_1_html_new = $temp_wrapper.html();
			jQuery('.js-price_button[data-id="0"]').html(price_button_1_html_new);
			jQuery('.js-price_button[data-id="1"]').html(price_button_2_html);
		});
		
		$root.on("blur", (event) => {
			this.inject_context($root, $list, $selected, $options, id);
			super.close_all(event);
		});
	}
	
	option_click_handler(event) {
		const $element = jQuery(event.currentTarget);
		let $clicked_element = jQuery($element.prop('outerHTML'));
		
		if (this.$list.find(`.js-${this.id}_option`).length) {
			yalwa.basics.bem_modifier(this.$list.find(`.js-${this.id}_option`), 'selected', 'remove');
		}
		this.selected_id = $element.data('id');
		yalwa.basics.bem_modifier($element, 'selected', 'add');
		this.$selected.html($clicked_element);
		this.close_all(event);
	}
}
